module.exports = __webpack_public_path__ + "static/media/wish-card-bg.50f23fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/wish-card-bg.png
// module id = 330
// module chunks = 6